import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputTextarea } from "primereact/inputtextarea";
import { useState } from "react";
import ModalSeplag from "../../../../../../components/ModalSeplag";
import RotuloSeplag from "../../../../../../components/RotuloSeplag";
import { printToast } from "../../../../../../config/global";
import { adicionarAnaliseGeralProgr, updatedAnaliseGeralProgr } from "../../../../../../service/Rag/lançamento";

 

const ModalAnaliseGeralProgrSeplag2024 = ({
  visibleModal,
  setVisibleModal,
  setActionModal,
  actionModal,
  setAtualizarData,
  dataRow,  
  dadosItemPrograma,
  cronograma,  
  infoUnidade,
}) => {
  const [data, setData] = useState({        
    indicadorSelected: dataRow.indicador ? dataRow.indicador : null,
    dataAnalisePrograma: dataRow.dataAnalisePrograma !== undefined ? dataRow.dataAnalisePrograma : "",
    descAnalisePrograma: dataRow.descAnalisePrograma !== undefined ? dataRow.descAnalisePrograma : "",
    maximoCaracteres: 4000, 
    numrAnaliseRecomendacao: dataRow.numrAnaliseRecomendacao !== undefined ? dataRow.numrAnaliseRecomendacao : null,    
  });  
  //console.log("chegou",dataRow)
  //console.log("chegouInfoUnidade",infoUnidade)
  const analiseItemAcaoOptions = [
    { name: "Indicador da Ação", code: 0 },
    { name: "Meta física", code: 1 },
    { name: "Execução Orçamentária", code: 2 },
    { name: "Outros", code: 3 },
  ];
  const analiseRecomendacaoAcaoOptions = [
    { name: "Baixo Impacto", code: 0 },
    { name: "Médio Impacto", code: 1 },
    { name: "Alto Impacto", code: 2 },
  ];

  const isValidDate = (dateString) => {
    const [day, month, year] = dateString.split("/").map(Number);
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  };

  const isValidAnalysisDate = (dataAnalisePrograma, startDateStr, endDateStr) => {    
    const [day, month, year] = dataAnalisePrograma.split("/").map(Number);
    const analysisDate = new Date(year, month - 1, day);
    //console.log("analysisDate:",analysisDate)

    const [startDay, startMonth, startYear] = startDateStr.split("/").map(Number);
    const startDate = new Date(startYear, startMonth - 1, startDay);

    const [endDay, endMonth, endYear] = endDateStr.split("/").map(Number);
    const endDate = new Date(endYear, endMonth - 1, endDay);

    const currentDate = new Date();

    // Verificações
    if (!dataAnalisePrograma || dataAnalisePrograma.trim() === "") {
      return "A data deve ser informada";
    }
    if (analysisDate > currentDate) {
      return "A ‘data de análise’ deve ser menor ou igual à ‘data atual";
    }
    if (analysisDate < startDate || analysisDate > endDate) {
      return "A ‘data de análise’ deve estar compreendida dentro do cronograma/prorrogação";
    }
  };

  const salvarAnaliseGeral = async () => {
    let now = new Date();
    let date = now.getDate() + "/" + (now.getMonth() + 1) + "/" + now.getFullYear();
    
    //console.log("Linha84",dadosItemPrograma)
    //console.log("cronograma",cronograma)
    let formAnalisePrograma = {
      ...dataRow,            
      programa: { idenPrograma: dadosItemPrograma.dadosItemRag.idenPrograma},  // Aqui estamos incluindo o objeto `programa`      
      dataInclusao: date,
    };

    formAnalisePrograma.dataAnalisePrograma = data.dataAnalisePrograma;
    formAnalisePrograma.descAnalisePrograma = data.descAnalisePrograma;    
    formAnalisePrograma.numrAnaliseRecomendacao = data.numrAnaliseRecomendacao;    
    formAnalisePrograma.statAnalisePrograma = 1;
    formAnalisePrograma.tipoAnalisePrograma = 1;

    //debugger
    //Montagem do primeiro paragrafo do email 
    let descEmail = `Processo RAG ${dadosItemPrograma.dadosItemRag.exercicio.ano}: foi inserida uma recomendação no item: ${infoUnidade.descricaoFiplan},
                       Programa: ${dadosItemPrograma.dadosItemRag.codgPrograma} - ${dadosItemPrograma.dadosItemRag.descPrograma}                        
                       com a Classificação: ${analiseRecomendacaoAcaoOptions.find((item) => item.code === data.numrAnaliseRecomendacao)?.name}.`;
                     //console.log("descEmail:",descEmail)                    

    //let descEmail = " " //AQUI provisorio  
    
    const errorMsg = isValidAnalysisDate(formAnalisePrograma.dataAnalisePrograma, cronograma.dataInicial, cronograma.dataFinal);
    if (errorMsg) {
      return printToast({ severity: "error", detail: errorMsg });
    }

    if (formAnalisePrograma.numrAnaliseRecomendacao === null){
      return printToast({severity: "error", detail: "Uma classificação deve ser selecionada"})
    }

    if (formAnalisePrograma.descAnalisePrograma.trim() === "") {
      return printToast({ severity: "error", detail: "Uma descrição para a análise/recomendação deve ser informada" });
    }   

    await adicionarAnaliseGeralProgr ({
      analisePrograma: { ...formAnalisePrograma},      
      descEmail: descEmail,
    }).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Ação Efetuada",
        detail: "Criado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
      setVisibleModal(false);
    });
  };

  const alterarAnaliseGeral = async () => {
    let formAnalisePrograma = { 
      ...dataRow, //Copia todos os valores
      programa: { idenPrograma: dadosItemPrograma.dadosItemRag.idenPrograma},  // Aqui estamos incluindo o objeto `programa`      
     };

    formAnalisePrograma.idenAnalisePrograma = dataRow.idenAnalisePrograma;
    formAnalisePrograma.dataAnalisePrograma = data.dataAnalisePrograma;
    formAnalisePrograma.descAnalisePrograma = data.descAnalisePrograma;
    formAnalisePrograma.numrAnaliseRecomendacao = data.numrAnaliseRecomendacao;    

    const errorMsg = isValidAnalysisDate(formAnalisePrograma.dataAnalisePrograma, cronograma.dataInicial, cronograma.dataFinal);
    if (errorMsg) {
      return printToast({ severity: "error", detail: errorMsg });
    }
    if (formAnalisePrograma.descAnalisePrograma.trim() === "") {
      return printToast({ severity: "error", detail: "Uma descrição para a análise/recomendação deve ser informada" });
    }   

    await updatedAnaliseGeralProgr({
      idenAnalisePrograma: dataRow.idenAnalisePrograma,
      postBody: formAnalisePrograma,
    }).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Programa Atualizada",
        detail: "Alterado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
      setVisibleModal(false);
    });
  };

  const indicadorOptionTemplate = (option) => {
    return (
      <div className="indicador-item">
        <div>{`${option.codgIndicador} - ${option.descIndicador}`}</div>
      </div>
    );
  };

  const formatarMilhar = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  return (
    <ModalSeplag
      titulo="Análise Geral do Programa pela equipe Central da SEPLAG"
      tamanho="76vw"
      type="NONE"
      visible={visibleModal}
      fechar={() => {
        setVisibleModal(false);
        setActionModal({
          edit: false,
          disbled: false,
          create: false,
        });
      }}
    >
      <div className="p-fluid grid line-height-6">
        <div className="field col-12 md:col-12 ">
          <div className="p-fluid grid line-height-4">            
            <div className="field col-12 md:col-4">
              <RotuloSeplag nome="Data">
                <InputMask
                  disabled={actionModal.disabled}
                  value={data.dataAnalisePrograma}
                  mask="99/99/9999"
                  placeholder="__/__/____"
                  onChange={(e) => {
                    setData((prevState) => ({
                      ...prevState,
                      dataAnalisePrograma: e.value,
                    }));
                  }}
                  className="p-inputtext-lg"
                ></InputMask>
              </RotuloSeplag>
            </div>
            <div className="field col-12 md:col-4">
              <RotuloSeplag nome="Classificação da Recomendação">
                <Dropdown
                  disabled={actionModal.disabled}
                  id="code"
                  emptyMessage="Dados não encontrados"
                  options={analiseRecomendacaoAcaoOptions}
                  value={data.numrAnaliseRecomendacao}
                  onChange={(e) => {
                    setData((prevState) => ({ 
                      ...prevState, 
                      numrAnaliseRecomendacao: e.value 
                    }));
                  }}
                  optionLabel="name"
                  optionValue="code"
                  placeholder="Selecione um item"
                />
              </RotuloSeplag>
            </div>
          </div>
          <div className="field col-12 md:col-12">
            <RotuloSeplag nome="Análise/recomendação para o item selecionado" cols="3">
              <InputTextarea
                value={data.descAnalisePrograma}
                autoResize
                maxLength={data.maximoCaracteres}
                disabled={actionModal.disabled}
                onChange={(e) => {
                  setData((prevState) => ({
                    ...prevState,
                    descAnalisePrograma: e.target.value,
                  }));
                }}
              />
              <span>
                {data.descAnalisePrograma === ""
                  ? `${formatarMilhar(data.maximoCaracteres)} caractere(s) restante(s)`
                  : ` ${formatarMilhar(data.maximoCaracteres - data.descAnalisePrograma.length)} caractere(s) restante(s)`}
              </span>
            </RotuloSeplag>
          </div>
        </div>
      </div>
      <div className="grid" style={{ margin: "1rem" }}>
        {actionModal.edit === true && (
          <div className="col">
            <Button label="Alterar" onClick={alterarAnaliseGeral} />
          </div>
        )}

        <div className="col">
          <Button
            label={actionModal.disabled === true ? "Fechar" : "Cancelar"}
            className="p-button-secondary"
            onClick={() => {
              setVisibleModal(false);
              setActionModal({
                edit: false,
                disbled: false,
                create: false,
              });
            }}
          />
        </div>
        {actionModal.create === true && (
          <div className="col">
            <Button label="Adicionar" onClick={salvarAnaliseGeral} />
          </div>
        )}
      </div>
    </ModalSeplag>
  );
};
export default ModalAnaliseGeralProgrSeplag2024;
